import { render, staticRenderFns } from "./KineticEffect.vue?vue&type=template&id=ddfd71f2&scoped=true"
import script from "./KineticEffect.vue?vue&type=script&lang=js"
export * from "./KineticEffect.vue?vue&type=script&lang=js"
import style0 from "./KineticEffect.vue?vue&type=style&index=0&id=ddfd71f2&prod&lang=scss"
import style1 from "./KineticEffect.vue?vue&type=style&index=1&id=ddfd71f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddfd71f2",
  null
  
)

export default component.exports